// extracted by mini-css-extract-plugin
export default {"root":"defaultCard_root__VC8JI"};